import { Wifi, Phone, Mail, MapPin, FileText, Scale, Award, BookOpen, ArrowRight, Facebook, Instagram } from "lucide-react";
import { COMPANY_INFO, LEGAL_DOCS } from "../data/constants";

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/logo-flowing.png" 
                alt="Flowing" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6">
              Internet por Fibra Óptica. Ofrecemos la mejor conexión de internet 
              de la región para tu hogar, negocio y empresa.
            </p>
            <a
              href={COMPANY_INFO.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-500 text-white px-5 py-3 rounded-full font-semibold hover:bg-green-600 transition-colors"
              data-testid="footer-whatsapp"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp
            </a>
            {/* Social Media */}
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://facebook.com/flowing.lat"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com/flowing.lat"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://tiktok.com/@flowing.lat"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li><a href="#inicio" className="text-gray-400 hover:text-orange-500 transition-colors">Inicio</a></li>
              <li><a href="#paquetes" className="text-gray-400 hover:text-orange-500 transition-colors">Paquetes</a></li>
              <li><a href="#cobertura" className="text-gray-400 hover:text-orange-500 transition-colors">Cobertura</a></li>
              <li><a href="#nosotros" className="text-gray-400 hover:text-orange-500 transition-colors">Nosotros</a></li>
              <li><a href="#faq" className="text-gray-400 hover:text-orange-500 transition-colors">Preguntas Frecuentes</a></li>
              <li>
                <a 
                  href="https://portal.flowing.lat" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-orange-500 hover:text-orange-400 transition-colors font-medium flex items-center gap-1"
                  data-testid="footer-portal"
                >
                  Portal de Clientes
                  <ArrowRight className="w-4 h-4" />
                </a>
              </li>
              <li>
                <a 
                  href="https://cfdi.flowing.lat" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-orange-500 hover:text-orange-400 transition-colors font-medium flex items-center gap-1"
                  data-testid="footer-facturacion"
                >
                  Facturación Electrónica
                  <ArrowRight className="w-4 h-4" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contacto</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-orange-500" />
                {COMPANY_INFO.phone}
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-orange-500" />
                {COMPANY_INFO.email}
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-orange-500 mt-1 flex-shrink-0" />
                <span>{COMPANY_INFO.officeAddress}</span>
              </li>
            </ul>
          </div>

          {/* Legal - IFT Compliance */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={LEGAL_DOCS.privacyNotice}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-link text-gray-400 hover:text-orange-500 transition-colors inline-flex items-center gap-2"
                  data-testid="legal-privacy"
                >
                  <FileText className="w-4 h-4" />
                  Aviso de Privacidad
                </a>
              </li>
              <li>
                <a
                  href={LEGAL_DOCS.userRights}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-link text-gray-400 hover:text-orange-500 transition-colors inline-flex items-center gap-2"
                  data-testid="legal-rights"
                >
                  <Scale className="w-4 h-4" />
                  Carta de Derechos Mínimos
                </a>
              </li>
              <li>
                <a
                  href={LEGAL_DOCS.authorization}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-link text-gray-400 hover:text-orange-500 transition-colors inline-flex items-center gap-2"
                  data-testid="legal-authorization"
                >
                  <Award className="w-4 h-4" />
                  Título de Autorización
                </a>
              </li>
              <li>
                <a
                  href={LEGAL_DOCS.commercialPractices}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-link text-gray-400 hover:text-orange-500 transition-colors inline-flex items-center gap-2"
                  data-testid="legal-practices"
                >
                  <BookOpen className="w-4 h-4" />
                  Código de Prácticas Comerciales
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-500 text-sm text-center md:text-left">
              <p className="font-semibold text-gray-400">{COMPANY_INFO.legalName}</p>
              <p>RFC: {COMPANY_INFO.rfc}</p>
              <p>{COMPANY_INFO.address}</p>
            </div>
            <div className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Flowing. Todos los derechos reservados.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
